module.exports = "/_next/static/images/constructionEnergy-bc4ed1109c0ecf07732e25c85e629fa5.webp";